import React from 'react';
import axiosInstance from '../api/axios';
import { trackPromise } from 'react-promise-tracker';
import Dashboards from './Dashboards';
import ReportChart from './ReportChart';
import { RiPrinterFill } from "react-icons/ri";
import ReportFirstChild from './ReportFirstChild';
import SpinnerContent from '../common/components/SpinnerContent';
import { DEBUG } from '../config';

class ReportData extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: props.username,
            token: props.token,
            studyId: props.studyId,
            studyName: props.studyName,
            quadro: props.quadro,
            quadros: props.quadros,
            quadrosTexto: props.quadrosTexto,
            selectedNode: props.selectedNode,
            selectedNodeLabel: props.selectedNodeLabel,
            parentNode: props.parentNode,
            htmlContent: "",
            hasHTML: false,
            dashboards: [],
            dashboardTitle: "",
            isDashboard: false,
            isQuadroNormal: false,
            blankOutput: false,
            gotData: false,
        };

        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.initializeState = this.initializeState.bind(this);
        this.createDashboards = this.createDashboards.bind(this);
        this.createBarModels = this.createBarModels.bind(this);
        this.renderHtmlContents = this.renderHtmlContents.bind(this);
        this.getReportDashBoards = this.getReportDashBoards.bind(this);
        this.getQuadroDashBoard = this.getQuadroDashBoard.bind(this);
        this.buildChart = this.buildChart.bind(this);
        this.buildStackedColChart = this.buildStackedColChart.bind(this);
        this.buildPieChart = this.buildPieChart.bind(this);
        this.printHTML = this.printHTML.bind(this);
        this.sanitize = this.sanitize.bind(this);
    }

    printHTML() {
        document.getElementById("printableIframe").contentWindow.print();
    }

    getReportDashBoards = async (nodeId) => {
        // CORREÇÃO: Usar props diretamente aqui também por segurança
        const username = this.props.username;
        const token = this.props.token;
        
        try {
            const response = await axiosInstance.post("/report/getdashboards", {}, {
                params: { username, token, nodeId }
            });
            const result = await response.data;
            var dashBoards = JSON.parse(result);
            return dashBoards;
        } catch (err) {
            console.error('ERRO [Report, ReportData, getReportDashBoards]: Falha ao obter Dashboards', err);
            return [];
        }
    }

    createDashboards(currentNode, parentNode, nodeLabel) { 
        var dashboardsList;
        if (currentNode !== 0) {
            dashboardsList = trackPromise(this.getReportDashBoards(currentNode));
        } else {
            dashboardsList = trackPromise(this.getReportDashBoards(parentNode));
        }
        
        this.setState({ 
            dashboards: dashboardsList,
            dashboardTitle: "Dashboard - " + nodeLabel, 
            isDashboard: true,
            isQuadroNormal: false
        });
    }

    getQuadroDashBoard() {
        const quadroDashboard = this.state.quadros.find((q) => q.id === this.state.quadro.dashboardDashId);
        return quadroDashboard;
    }

    buildChart() {}
    buildStackedColChart() {}
    buildPieChart() {}

    createBarModels() {
        var quadro = this.state.quadro;
        var quadroDashboard = this.getQuadroDashBoard();
        var tipoQuadroDashboard = -1;
        if (typeof quadroDashboard !== 'undefined') {
            tipoQuadroDashboard = quadroDashboard.gTipo;
        }
        var apresentaDashboard = quadro.apresentaDashboard;
        var tipoQuadro = quadro.gTipo;
        var tipoDadosQuadro = quadro.tipoDados;

        if ((apresentaDashboard === 0 && tipoQuadro === 2) || (apresentaDashboard === 1 && tipoQuadroDashboard === 2)) {
            this.buildChart();
        } else if ((tipoQuadro === 1 && tipoDadosQuadro === 3) ||
            (apresentaDashboard === 0 && tipoQuadro === 6) ||
            (apresentaDashboard === 1 && tipoQuadroDashboard === 6)) {
            this.buildStackedColChart();
        } else if ((apresentaDashboard === 0 && tipoQuadro === 4) ||
            (apresentaDashboard === 1 && tipoQuadroDashboard === 4)) {
            this.buildPieChart();
        }
    }

    renderHtmlContents = async (nodeIdToFetch) => {
        // CORREÇÃO: Ler diretamente das props! O this.setState é assíncrono, 
        // logo o this.state.studyId podia estar desatualizado no 1º carregamento.
        const username = this.props.username;
        const token = this.props.token;
        const studyId = this.props.studyId;
        
        // Se o selectedNode for 0, asseguramos que cai no parentNode
        const fallbackNode = this.props.selectedNode === 0 ? this.props.parentNode : this.props.selectedNode;
        const nodeId = nodeIdToFetch || fallbackNode;
        
        this.setState({ hasHTML: false });

        try {
            const response = await axiosInstance.post("/report/gethtmlcontents", {}, {
                params: { username, token, studyId, nodeId }
            });
            var result = response.data;
            if (typeof result === 'string' && result.toLowerCase().includes('não encontrado') && result.includes('DATA E')) {
                if (DEBUG){
                    console.log("HTML BRUTO RECEBIDO DO JAVA:", result);
                }
                console.error("ERRO [Report, ReportData, renderHtmlContents]: Ficheiro em falta no servidor ->", result);
                
                const nomeQuadro = this.props.selectedNodeLabel ? this.props.selectedNodeLabel : "selecionado";
                result = `<div style="padding: 40px 20px; text-align: center; font-family: sans-serif;">
                              <h3 style="color: #555;">Conteúdo do quadro '${nomeQuadro}' não encontrado.</h3>
                              <p style="color: #777;">Por favor, contate o serviço técnico da DATA E.</p>
                          </div>`;
            }
            this.setState({ htmlContent: result, hasHTML: true });          
        } catch (err) {
            console.error('ERRO [Report, ReportData, renderHtmlContents]: HTML não encontrado ou erro de servidor.', err);
            this.setState({ hasHTML: false, htmlContent: "" });
        }
    }

    initializeState = async () => {
        const currentQuadro = this.props.quadro;
        const currentNode = this.props.selectedNode;

        this.setState({
            studyId: this.props.studyId,
            studyName: this.props.studyName,
            selectedNode: currentNode,
            selectedNodeLabel: this.props.selectedNodeLabel,
            quadro: currentQuadro,
            quadros: this.props.quadros,
            quadrosTexto: this.props.quadrosTexto,
            parentNode: this.props.parentNode,
            gotData: false
        });

        if (!currentQuadro) return;

        var tipoDados = currentQuadro.tipoDados;
        
        if (tipoDados === 9) {
            this.createDashboards(currentNode, this.props.parentNode, this.props.selectedNodeLabel);
            this.setState({ blankOutput: false, isDashboard: true, isQuadroNormal: false });
        } else if (tipoDados === 1 || tipoDados === 2 || tipoDados === 3 || tipoDados === 4 || tipoDados === 5) {
            this.setState({ blankOutput: false, isDashboard: false, isQuadroNormal: true });
        } else if (tipoDados === 100) {
            let nodeToFetch = currentNode;
            if (currentNode === 0) {
                nodeToFetch = this.props.parentNode;
                this.setState({ selectedNode: this.props.parentNode });
            }
            await this.renderHtmlContents(nodeToFetch);
            this.setState({ blankOutput: false, isDashboard: false });
        } else {
            this.setState({ blankOutput: true, isDashboard: false, isQuadroNormal: false });
        }
        
        const quadroTexto = this.props.quadrosTexto.find((qt) => String(qt.id) === String(currentNode));
        this.setState({ contentTitle: quadroTexto ? quadroTexto.nome : "", gotData: true });
    }

    componentDidUpdate = async (prevProps) => {
        // Se o ID mudar, reset forçado!
        if (this.props.selectedNode !== prevProps.selectedNode) {
            this.setState({ 
                gotData: false, 
                blankOutput: false, 
                hasHTML: false, 
                selectedNode: this.props.selectedNode, 
                isDashboard: false, 
                isQuadroNormal: false, 
                quadro: this.props.quadro, 
                htmlContent: "", 
            });
            this.initializeState();
        }
    }

    componentDidMount = async () => {
        this.initializeState();
    }

    sanitize(html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        return doc.innerHTML;
    }

    render() {
        return (
            <div style={{ backgroundColor: '#fff', color: '#000', padding: 20, width: "100%", minHeight: 649 }}>
                <div className="tabs-container" style={{ width: "900px", marginLeft: "auto", marginRight: "auto", textAlign: "left" }}>
                    {!this.state.gotData && <SpinnerContent/>}
                    
                    {this.state.gotData && this.state.blankOutput &&
                        <ReportFirstChild 
                            key={this.state.selectedNode}
                            studyId={this.state.studyId}
                            studyName={this.state.studyName}
                            quadroId={this.state.selectedNode}
                            username={this.state.username}
                            token={this.state.token}
                            quadros={this.state.quadros}
                            quadrosTexto={this.state.quadrosTexto}
                        />
                    }
                    {this.state.hasHTML &&
                        <div>
                            <div width="100%" style={{ minHeight: 600 }} key={new Date().getTime()}>                            
                                <iframe 
                                    title={`Conteúdo HTML - ${this.state.contentTitle || 'Documento'}`} 
                                    id="printableIframe" 
                                    name="printableIframe" 
                                    width="950" 
                                    height="600" 
                                    frameBorder={0} 
                                    srcDoc={this.state.htmlContent}
                                />
                            </div>
                            <center>
                                <br />
                                <RiPrinterFill onClick={this.printHTML} style={{ fontSize: "32px" }} title="Imprimir"/>
                            </center>
                        </div>
                    }
                    {this.state.isQuadroNormal &&
                        <div>                            
                            <ReportChart
                            
                                key={this.state.selectedNode}                                
                                studyId={this.state.studyId}
                                studyName={this.state.studyName}
                                quadroId={this.state.selectedNode}
                                username={this.state.username}
                                token={this.state.token}
                                quadros={this.state.quadros}
                                quadrosTexto={this.state.quadrosTexto}
                            />
                        </div>
                    }
                    {this.state.isDashboard &&
                        <div>
                            <h2>{this.state.contentTitle}</h2>
                            <Dashboards
                                key={this.state.selectedNode}
                                
                                studyId={this.state.studyId}
                                studyName={this.state.studyName}
                                nodeId={this.state.selectedNode}
                                dashboards={this.state.dashboards}
                                quadros={this.state.quadros}
                                quadrosTexto={this.state.quadrosTexto}
                                username={this.state.username}
                                token={this.state.token}
                            />
                        </div>
                    }
                </div>
            </div>
        );
    }
}
export default ReportData;